module.exports = __webpack_public_path__ + "static/nutzungsmischung_und_zentren-6905bd5c47914fdf9a5d0cff5cba661a.png";